import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {PolicyListActions} from "./model";
import {RootState} from "../../../redux/store";

export const PolicyListController = (page, size, userQuery, sorter) => {
    const dispatch = useDispatch();

    const {
        value: {data, totalCount},
        progress,
    } = useSelector(
        (rootState: RootState) => rootState.policyList.policyList
    );

    useEffect(() => {
        dispatch(
            PolicyListActions.getPolicyList({
                page: page,
                size: size,
                userQuery: userQuery,
                sorter: sorter,
            }),
        );
    }, [dispatch, page, size, JSON.stringify(userQuery), JSON.stringify(sorter)]);

    return {
        data,
        totalCount,
        isLoading: !!progress,
    };
};